import useSWR from "swr";
import { getCurrentUser } from "@yardzen/rest-api-client";
import { useMemo } from "react";

export interface UseCurrentUserOptions {
  // When false, skips the /auth/current-user request entirely. Callers on
  // public surfaces must disable this: the request 401s when logged out and
  // the shared api client redirects 401s to /login.
  enabled?: boolean;
}

export const useCurrentUser = ({
  enabled = true,
}: UseCurrentUserOptions = {}) => {
  const { data, error, isLoading } = useSWR(
    enabled ? "/current-user" : null,
    getCurrentUser,
    {
      revalidateOnFocus: false,
    },
  );

  return useMemo(
    () => ({
      user: data?.data,
      isLoading,
      isError: error,
    }),
    [data?.data, isLoading, error],
  );
};
